import React from 'react';
import { Container, Navbar, NavbarBrand } from 'components/apollo';
import { Row, Column } from 'components/grid';
import iconImage from '../../router/AFRY-Logotype-Horizontal_White.svg';
import './register-terms.css';

const contentCols = {
  mobile: { size: 12, offset: 0 },
  tablet: { size: 12, offset: 0 },
  desktop: { size: 8, offset: 2 },
  largeDesktop: { size: 8, offset: 2 },
};

const RegisterTerms = () => (
  <div className="register-terms">
    <Navbar dark fixed="top" expand="large">
      <Container>
        <NavbarBrand icon={iconImage} />
      </Container>
    </Navbar>

    <Container className="register-mobile-container">
      <Row>
        <Column {...contentCols}>
          <div className="register-terms-content">
            <h2>Terms and conditions</h2>

            <section>
              <h3>Partner Eligibility, Conduct Requirements and AFRY's Right to Exclusion</h3>
              <p>
                <em>By registering as a Partner with AFRY, you acknowledge and accept that AFRY reserves the right to suspend, exclude, or take other appropriate measures against any Partner who meets any one or more of the following criteria:</em>
              </p>
              <p>
                • <strong>Breaches the terms of the applicable agreement</strong> <em>entered into with AFRY.</em>
                <br />
                • <strong>Fails to fulfil background check requirements</strong> <em>requested by the end client in connection with an assignment.</em>
                <br />
                • <strong>Violates the Code of Conduct</strong> <em>of the end client and/or AFRY, including but not limited to requirements relating to business ethics, anti-corruption, human rights, and sustainability.</em>
                <br />
                • <strong>Has committed, or is found to have committed, criminal violations</strong> <em>that AFRY deems incompatible with its values or with the requirements of its clients.</em>
              </p>
              <p>
                AFRY is committed to maintaining the highest standards of integrity, professionalism, and compliance across its partner network. Partners are expected to uphold these standards throughout the entirety of their engagement with AFRY. AFRY's decision to exclude or take action against a Partner under any of the above circumstances is at AFRY's sole discretion and without prejudice to any other rights or remedies available to AFRY under the applicable agreement or applicable law.
              </p>
            </section>

            <section>
              <h3>Your personal information</h3>
              <p>
                Each AFRY Network Profile must be registered with an individual user account,
                using a personal email address as your username.
              </p>
            </section>

            <section>
              <h3>GDPR and self-registration</h3>
              <p>
                Due to GDPR, all consultants need to register their profile themselves. This means
                you, and only you, may register your own profile.
              </p>
              <p>
                If you're a sales manager, please ask your consultants to add their own profiles.
                You cannot register a profile on someone else's behalf.
              </p>
            </section>

            <section>
              <h3>Already registered?</h3>
              <p>
                If you already have a profile, there's no need to sign up again. Log in <a target="_blank" rel="noopener noreferrer" href="https://portal.afry.com">here</a> to 
                access your account.
              </p>
            </section>

            <section>
              <h3>Updating your profile</h3>
              <p>
                If you're already registered and want to update any information, such as your
                company name, organization number, or similar details, please do not create a
                second profile. Duplicate profiles aren't allowed in our system.
              </p>
              <p>
                For help with any update or change, contact us at{' '}
                <a href="mailto:PartnerBusinessSupport@AFRY.com">
                  PartnerBusinessSupport@AFRY.com
                </a>{' '}
                for further assistance.
              </p>
            </section>

            <section>
              <h3>AFRY Available Assignments policy</h3>
              <p>
                AFRY Available Assignments are considered AFRY's assets and may only be used for
                the purposes decided by AFRY.
              </p>
              <p>
                As a registered partner, you may download or copy an Available Assignment for your
                own use and to share with your employees. You may not repost or republish AFRY's
                Available Assignments outside AFRY's platform without AFRY's written approval.
              </p>
            </section>
          </div>
        </Column>
      </Row>
    </Container>
  </div>
);

export default RegisterTerms;
